import { ResourceUtils } from '../ResourceUtils';

export class FlowCardUtils {
  static getTitle(card) {
    if (card == null) {
      return '';
    }

    // todo:
    // homey-core support
    const zoneName = card.uriObj?.meta?.zoneName;
    return `${ResourceUtils.getOwnerName(card) ?? ''}${zoneName ? ` - ${zoneName}` : ''}`;
  }

  static generateAdvancedFlowCardData(card) {
    return {
      id: card.id,
      droptoken: card.droptoken ? null : undefined,
      args:
        card.args?.reduce((accumulator, arg) => {
          accumulator[arg.name] = arg.value ?? undefined;
          return accumulator;
        }, {}) ?? undefined,
    };
  }

  static generateFlowCardDataIdProperties(card) {
    return {
      id: card.id,
    };
  }
}
